import React from "react";

function TomoCard({ lastFour }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 130 82"
    >
      <defs>
        <radialGradient
          id="b"
          cx="89.974%"
          cy="11.491%"
          r="100%"
          fx="89.974%"
          fy="11.491%"
          gradientTransform="matrix(0 1 -.63077 0 .972 -.785)"
        >
          <stop offset="0%" stopColor="#1E3D3F" />
          <stop offset="100%" stopColor="#030E0E" />
        </radialGradient>
        <rect id="a" width="130" height="82" x="0" y="0" rx="6.5" />
        <text
          id="e"
          fill="#FFF"
          fontFamily="Helvetica"
          fontSize="text-9"
          fontWeight="font-normal"
        >
          <tspan x="28.724" y="67">
            {`**** **** **** ${lastFour}`}
          </tspan>
        </text>
        <filter
          id="d"
          width="107.7%"
          height="133.3%"
          x="-3.8%"
          y="-11.9%"
          filterUnits="objectBoundingBox"
        >
          <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation="1"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
          />
        </filter>
        <linearGradient
          id="f"
          x1="76.607%"
          x2="39.648%"
          y1="24.49%"
          y2="75.51%"
        >
          <stop offset="0%" stopColor="#FFF" />
          <stop offset="100%" stopColor="#DDF0ED" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g transform="translate(-361 -123) translate(337 96) translate(24 26) translate(0 1)">
          <mask id="c" fill="#fff">
            <use xlinkHref="#a" />
          </mask>
          <use fill="url(#b)" xlinkHref="#a" />
          <ellipse
            cx="146.367"
            cy="17.705"
            fill="#26E3BA"
            mask="url(#c)"
            opacity="0.599"
            rx="24.781"
            ry="49.392"
            transform="rotate(-10 146.367 17.705)"
          />
          <ellipse
            cx="147.302"
            cy="9.784"
            fill="#26E3BA"
            mask="url(#c)"
            opacity="0.599"
            rx="24.781"
            ry="44.266"
            transform="rotate(-10 147.302 9.784)"
          />
          <ellipse
            cx="148.237"
            cy="3.727"
            fill="#26E3BA"
            mask="url(#c)"
            rx="24.781"
            ry="41.005"
            transform="rotate(-10 148.237 3.727)"
          />
        </g>
        <g transform="translate(-361 -123) translate(337 96) translate(24 26) translate(0 1) translate(16 15)">
          <path
            fill="#26E3BA"
            d="M0 0.0125535639L0.00290275775 1.25451948 1.59174126 1.24991651 1.60250955 5.77777778 2.81146133 5.77443016 2.80069304 1.24667351 4.38934426 1.24207053 4.3864415 0z"
          />
          <path
            fill="#26E3BA"
            d="M7.188 4.75c-1.397 0-1.541-1.286-1.552-1.68-.013-.505.141-.98.424-1.304.277-.316.655-.477 1.126-.479.466-.005.841.155 1.115.463.284.319.443.794.436 1.304-.012.818-.423 1.694-1.543 1.697h-.006zM7.192.064a.29.29 0 00-.01 0c-.86.002-1.582.328-2.086.944-.444.542-.688 1.272-.686 2.054.004 1.456.864 2.922 2.777 2.922h.01C9.091 5.978 9.951 4.5 9.963 3.04c.006-.806-.269-1.578-.754-2.12-.503-.561-1.2-.857-2.017-.857z"
          />
          <path
            fill="#26E3BA"
            d="M15.022167 0.155638078L13.4857453 2.38086649 11.9383676 0.164199823 10.6196224 0.167810197 10.6336537 5.85703802 11.8744582 5.85363395 11.8654244 2.22520778 13.3064144 4.2794076 13.6293253 4.27858238 15.0978974 2.21530504 15.1068351 5.84476275 16.3476396 5.84146183 16.3336083 0.152234011z"
          />
          <path
            fill="#26E3BA"
            d="M19.746 4.714c-1.397 0-1.541-1.286-1.552-1.681-.013-.504.141-.979.424-1.303.277-.317.655-.478 1.126-.479h.005c.464 0 .837.156 1.11.463.284.318.443.794.436 1.304-.012.818-.423 1.693-1.543 1.696h-.006zM19.75.026h-.01c-.86.003-1.582.33-2.086.944-.444.543-.688 1.272-.686 2.055.004 1.455.864 2.922 2.777 2.922h.01c1.894-.006 2.754-1.482 2.766-2.943.006-.806-.269-1.579-.754-2.12-.502-.561-1.2-.858-2.017-.858z"
          />
          <path
            fill="#FFF"
            d="M27.094 4.165a1.709 1.709 0 01-1.199.508h-.007c-1.19 0-1.623-.862-1.631-1.67-.005-.47.149-.917.423-1.225.289-.325.706-.497 1.207-.499h.004c.445 0 .852.165 1.146.465l.092.094.845-.86-.108-.111c-.547-.562-1.23-.858-1.975-.858h-.007c-.864.002-1.593.308-2.107.884-.48.54-.753 1.31-.747 2.115.01 1.349.765 2.92 2.857 2.92h.011c.807-.001 1.514-.294 2.045-.846l.104-.109-.86-.907-.093.099zM31.987 2.059a.73.73 0 01-.17.487c-.13.148-.328.226-.574.226l-1.341.004-.004-1.423 1.341-.004h.003c.548 0 .744.382.745.71zm.067 1.755c.751-.253 1.176-.89 1.173-1.782C33.224.71 32.193.105 31.236.102L30.022.1C29.61.1 29.2.099 28.79.1h-.136l.015 5.697 1.24-.004-.004-1.801.738-.002 1.503 1.797 1.348-.004v-.279l-1.44-1.691z"
          />
          <path
            fill="#FFF"
            d="M35.4221614 4.477514L35.4198549 3.56212938 38.2037124 3.55459917 38.2006371 2.30695697 35.4167796 2.31448718 35.414377 1.37609932 38.3010662 1.36805335 38.2978947 0.0819348659 34.1778011 0.0930754495 34.1919284 5.78240642 38.3120221 5.77126584 38.3087546 4.46957118z"
          />
          <path
            fill="#FFF"
            d="M40.356 4.487l-.008-3.148.922-.003h.006c1.052 0 1.45.79 1.47 1.528.014.467-.118.883-.37 1.171-.258.297-.628.448-1.098.45l-.922.002zm.92-4.414a.31.31 0 00-.01 0L39.112.08l.014 5.69 2.156-.006c.829-.003 1.522-.293 2.004-.84.463-.527.71-1.259.695-2.061-.014-.746-.253-1.428-.674-1.922-.483-.567-1.184-.867-2.03-.867z"
          />
          <path
            fill="#FFF"
            d="M44.8305944 0.063057766L44.8447217 5.75228559 46.0781262 5.74898467 46.0639988 0.0597568523z"
          />
          <path
            fill="#FFF"
            d="M50.9862955 1.26887121L50.9832202 0.0442322429 46.4813036 0.0564043619 46.4842828 1.28114648 48.114983 1.27671088 48.126035 5.74129973 49.3667434 5.73799882 49.3556914 1.27340996z"
          />
        </g>
        <g
          fill="#FFF"
          fillOpacity="1"
          transform="translate(-361 -123) translate(337 96) translate(24 26) translate(0 1)"
        >
          <use filter="url(#d)" xlinkHref="#e" />
          <use xlinkHref="#e" />
        </g>
        <g transform="translate(-361 -123) translate(337 96) translate(24 26) translate(0 1) translate(19 37)">
          <rect
            width="14"
            height="10"
            x="0"
            y="0"
            fill="url(#f)"
            fillRule="evenodd"
            rx="2.5"
          />
          <rect
            width="4.289"
            height="5.364"
            x="4.856"
            y="2.318"
            stroke="#323232"
            strokeWidth="1"
            rx="2"
          />
          <path
            fill="#323232"
            fillRule="evenodd"
            d="M9.333 3.03H14V4.029999999999999H9.333z"
          />
          <path
            fill="#323232"
            fillRule="evenodd"
            d="M6.844 0H7.844V2.121H6.844z"
          />
          <path
            fill="#323232"
            fillRule="evenodd"
            d="M6.844 7.879H7.844V10H6.844z"
          />
          <path
            fill="#323232"
            fillRule="evenodd"
            d="M9.333 4.848H14V5.848H9.333z"
          />
          <path
            fill="#323232"
            fillRule="evenodd"
            d="M9.333 6.667H14V7.667H9.333z"
          />
          <path
            fill="#323232"
            fillRule="evenodd"
            d="M0 3.03H4.667V4.029999999999999H0z"
          />
          <path fill="#323232" fillRule="evenodd" d="M0 4.848H4.667V5.848H0z" />
          <path fill="#323232" fillRule="evenodd" d="M0 6.667H4.667V7.667H0z" />
        </g>
      </g>
    </svg>
  );
}

TomoCard.defaultProps = {
  lastFour: 8888,
}

export default TomoCard;
